export default __webpack_public_path__ + "static/media/home-icon.26618b29.webp";